'use client';

import SurveyAiFormsAiSectionQuestionTitle from './survey-ai-forms-ai-section-question-title';
import { useAiOpenEndedQuestion } from './survey-ai-forms-ai-section-question.hooks';
import type { AISectionQuestionsBaseProps } from './survey-ai-forms-ai-section-questions.types';
import SurveyAiFormsInputComposer from './survey-ai-forms-input-composer';

interface Props extends AISectionQuestionsBaseProps {
  value: string;
  onChange: (value: string) => void;
  loading?: boolean;
}

export default function SurveyAiFormsAiSectionOpenEndedQuestion({
  question,
  value,
  onChange,
  onSubmit,
  onNext,
  responseMode,
  isActive = true,
  onFocus,
  registerVoiceStopCallback,
  loading = false,
  isMobile = false,
  isUserVoiceEnabled = false,
}: Props) {
  // Use AI open-ended question hook for business logic
  const { isListening, canSubmit, handleInputComposerSubmit } =
    useAiOpenEndedQuestion({
      question,
      value,
      onChange,
      onSubmit,
      onNext,
      hasValue: value.trim().length > 0,
    });

  return (
    <div
      data-test='open-ended-question'
      className='flex w-full flex-col gap-6 md:gap-8'
    >
      <SurveyAiFormsAiSectionQuestionTitle
        text={question.text}
        assets={question.assets}
      />

      {/* Input Composer */}
      <SurveyAiFormsInputComposer
        value={value}
        onChange={onChange}
        onSubmit={handleInputComposerSubmit}
        canSubmit={canSubmit}
        responseMode={responseMode}
        isActive={isActive}
        onFocus={onFocus}
        registerVoiceStopCallback={registerVoiceStopCallback}
        instanceId={question.id}
        isListening={isListening}
        questionType={question.type}
        loading={loading}
        isMobile={isMobile}
        isUserVoiceEnabled={isUserVoiceEnabled}
      />
    </div>
  );
}
